export const SECONDARY = {
  DARK: '#115e4a',
  DEFAULT: '#216e54',
  LIGHT: '#c5e4d8',
  LIGHTER: '#deeee8',
} as const;
